import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/styles.scss'
import App from './App'
import './i18n'
import LoadingPage from './pages/Other/LoadingPage'
import * as serviceWorker from './serviceWorker'
import { recoveryAuthFromLocalStorage } from './apis/apis'
import { initSentry } from './lib/sentry'

recoveryAuthFromLocalStorage()
initSentry()

const container = document.getElementById('root')
const root = createRoot(container)

const render = (Component) => {
  root.render(
    <Suspense fallback={<LoadingPage />}>
      <Component />
    </Suspense>
  )
}

render(App)



serviceWorker.unregister()
